function Directive() {
  return {
    restrict: 'E',
    replace: true,
    template: '<span class="{{ star.icon }}" ng-repeat="star in stars"></span>',
    scope: {
      ratingAverage: '='
    },
    controller: 'venueRatingCtrl',
    priority: 20
  };
}

Directive.$inject = [];

export default Directive;



// WEBPACK FOOTER //
// ./src/directives/venueRating/index.js